import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { FaEllipsisV } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { setMessage } from '../../../store/redux/slices/alertMessageSlice';

const sizes = {
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  desktop: '1800px',
};

export const device = {
  tablet: `(max-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #333;
  padding: 8px 0;
  position: relative;
  padding-left: 120px;
  padding-right: 120px;
  margin-top: 100px;
  @media only screen and ${device.tablet} {
    height: 60px;
    padding: 15px 24px;
    margin-top: unset;
  }
`;

const HeaderText = styled.div`
  display: flex;
  @media only screen and ${device.tablet} {
    flex-direction: column;
    justify-content: flex-end;
    flex-wrap: unset;
    align-items: flex-start;
  }
`;

const Info = styled.div`
  display: flex;
  align-items: center;
`;

const Avatar = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
`;

const MenuButton = styled.div`
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
`;

const Dropdown = styled.div`
  position: absolute;
  top: 24px;
  right: 120px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  width: 150px;
  background: #f5f5f5;
  display: ${(props) => (props.open ? 'block' : 'none')};
`;

const DropdownItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 8px;
  text-align: left;
  &:hover {
    background: #28955a;
    color: #ffffff;
    border-radius: unset;
  }
`;

const HeaderDescription = styled.div`
  margin-left: 5px;
  @media only screen and ${device.tablet} {
    margin-left: unset;
  }
`;

const BlogTitleHeader = ({ data }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const dropdownRef = useRef(null);
  const url = encodeURIComponent(window.location.href);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const dispatch = useDispatch();
  const date = new Date(data?.created_at);
  return (
    <Container>
      <Info>
        <Avatar>👤</Avatar>
        <HeaderText>
          <span>{data?.author}</span>
          <HeaderDescription>
            {date?.toLocaleDateString('en-US', {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
            })}{' '}
            &middot; {data?.time_to_read} read
          </HeaderDescription>
        </HeaderText>
      </Info>
      <div ref={dropdownRef}>
        <MenuButton title='Share' onClick={() => setMenuOpen(!menuOpen)}>
          <FaEllipsisV />
        </MenuButton>
        <Dropdown open={menuOpen}>
          <DropdownItem
            onClick={() => {
              window.open(
                `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                  url
                )}`,
                '_blank'
              );
              setMenuOpen(false);
            }}
          >
            Share on Facebook
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              window.open(
                `https://twitter.com/intent/tweet?url=${encodeURIComponent(
                  url
                )}`,
                '_blank'
              );
              setMenuOpen(false);
            }}
          >
            Share on Twitter
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              window.open(
                `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
                  window.location.href
                )}`,
                '_blank'
              );
              setMenuOpen(false);
            }}
          >
            Share on LinkedIn
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              navigator.clipboard.writeText(window.location.href);
              dispatch(
                setMessage({
                  message: 'Link copied successfully!!',
                  type: 'Success',
                })
              );
              setMenuOpen(false);
            }}
          >
            Copy Link
          </DropdownItem>
        </Dropdown>
      </div>
    </Container>
  );
};

export default BlogTitleHeader;
